import React from 'react';

import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import BN from 'bn.js';

function BigIntegerTextField (props) {
  const {
    value,
    mandatory = true,
    readOnly = false,
    disabled = false,
    validator,
    ...other
  } = props;

  let icon = <CheckCircleOutlineIcon style={{color: green[700]}} />;
  let error = false;
  let helperText = ' ';

  const trimmedValue = value.trim ();
  const lowerCaseValue = trimmedValue.toLowerCase ();

  if (readOnly || disabled || (!mandatory && lowerCaseValue === '')) {
    // Do nothing
  } else if (!lowerCaseValue.match (/^(0x[0-9a-f]+|0b[01]+|[0-9]+)$/)) {
    icon = <HighlightOffIcon style={{color: red[700]}} />;
    error = true;
    helperText = lowerCaseValue ? 'Invalid number' : 'Enter valid number, please';
  } else if (validator) {
    const bn =
      lowerCaseValue.startsWith ('0x') ? new BN (lowerCaseValue.substring (2), 16) :
      lowerCaseValue.startsWith ('0b') ? new BN (lowerCaseValue.substring (2), 2) :
      new BN (lowerCaseValue);

    const validatorMessage = validator (bn);
    if (validatorMessage) {
      icon = <HighlightOffIcon style={{color: red[700]}} />;
      error = true;
      helperText = validatorMessage;
    }
  }

  return (
    <TextField disabled={disabled}
               placeholder={readOnly || disabled ? undefined : '0'}
               helperText={helperText}
               error={error}
               value={value}
               InputLabelProps={{ shrink: true }}
               InputProps={{
                 readOnly: readOnly,
                 startAdornment: readOnly || disabled ? undefined : (
                   <InputAdornment position="start">
                     {icon}
                   </InputAdornment>
                 )
               }}
               variant="outlined"
               {...other} />
  );
}

export default BigIntegerTextField;
